import { z } from 'zod';

import { PaymentDueId, PayoffId } from '../BrandedIds';
import { EmailAttachment } from '../EmailAttachment';
import { ExternalPayoffQuoteEmail, MortgageeLetterEmail } from '../emails';
import { ExternalPaymentDueEmail, ExternalPayoffQuoteAttachedEmail } from '../emails/Templates';
import { EmailString } from '../validations';
import { BaseLoanEvent } from './BaseLoanEvent';

const SendExternalEmailBaseEvent = z.object({
  ...BaseLoanEvent.shape,
  type: z.literal('sendExternalEmail'),
  emailRecipientName: z.string().optional(),
  emailRecipient: EmailString,
  attachments: z.array(EmailAttachment).optional(),
});
type SendExternalEmailBaseEvent = z.infer<typeof SendExternalEmailBaseEvent>;

const SendNoContextExternalEmailEvent = z.object({
  ...SendExternalEmailBaseEvent.shape,
  emailTemplate: MortgageeLetterEmail,
});
type SendNoContextExternalEmailEvent = z.infer<typeof SendNoContextExternalEmailEvent>;

const SendPayoffExternalEmailEvent = z.object({
  ...SendExternalEmailBaseEvent.shape,
  emailTemplate: ExternalPayoffQuoteEmail,
  payoffId: PayoffId,
});
type SendPayoffExternalEmailEvent = z.infer<typeof SendPayoffExternalEmailEvent>;

const SendPayoffAttachedExternalEmailEvent = z.object({
  ...SendExternalEmailBaseEvent.shape,
  emailTemplate: ExternalPayoffQuoteAttachedEmail,
  payoffId: PayoffId,
  attachments: z.array(EmailAttachment),
});
type SendPayoffAttachedExternalEmailEvent = z.infer<typeof SendPayoffAttachedExternalEmailEvent>;

const SendPaymentDueExternalEmailEvent = z.object({
  ...SendExternalEmailBaseEvent.shape,
  emailTemplate: ExternalPaymentDueEmail,
  paymentDueId: PaymentDueId,
  attachments: z.array(EmailAttachment),
});
type SendPaymentDueExternalEmailEvent = z.infer<typeof SendPaymentDueExternalEmailEvent>;

export const SendExternalEmailEvent = z.discriminatedUnion('emailTemplate', [
  SendNoContextExternalEmailEvent,
  SendPayoffExternalEmailEvent,
  SendPayoffAttachedExternalEmailEvent,
  SendPaymentDueExternalEmailEvent,
]);
export type SendExternalEmailEvent = z.infer<typeof SendExternalEmailEvent>;
